import axios from 'axios'
import store from './store'
import qs from 'querystring'

const serverIp = 'liveabc-taichung4gapi.azurewebsites.net'
const appPath = '/api'
const protocal = 'https'
export const apiPath = protocal + '://' + serverIp + appPath

const api = axios.create({
  baseURL: apiPath,
  timeout: 60000,
  headers: {
    'Authorization': 'bearer ' + window.localStorage.getItem('token')
  }
})

api.interceptors.request.use(function (config) {
  config.headers.Authorization = 'bearer ' + window.localStorage.getItem('token')
  store.commit('isLoading', true)
  return config
}, function (error) {
  return Promise.reject(error)
})

api.interceptors.response.use(function (response) {
  store.commit('isLoading', false)
  return response
}, function (error) {
  store.commit('isLoading', false)
  if (error.response && error.response.status === 401) {
    window.location = window.location.pathname + '#/Logout'
    store.commit('setErrorMessage', '已登出，請重新登入')
  } else if (error.response.data) {
    var msg = error.response.data.Message || error.response.data.error_description
    if (msg === '') {
      msg = '未知錯誤'
    }
    store.commit('setErrorMessage', msg)
  } else {
    store.commit('setErrorMessage', error.message)
  }
  return Promise.reject(error)
})

export default {
  Account: {
    Login: (username, password) => {
      return api.post('/Account/Login', qs.stringify({
        'username': username,
        'password': password,
        'grant_type': 'password'
      }))
    },

    Profile: () => {
      return api.get('/Account/UserInfo')
    },

    Register: (data) => {
      data = data || {}

      var postdata = {
        username: data.username,
        password: data.password,
        realname: data.realname,
        phone: data.phone
      }

      return api.post('/Account/Register', postdata)
    },

    CheckUserName: (username) => {
      return api.post('/Account/CheckUserName', qs.stringify({
        'username': username
      }))
    },

    ForgotPassword: (username) => {
      return api.post('/Account/ForgotPassword?username=' + username)
    }
  },

  Point: {
    Info: () => {
      return api.get('/UserPoint')
    },

    Record: (pageIndex, type) => {
      pageIndex = pageIndex || 1
      type = type || ''
      return api.get('/UserPoint/Record?type=' + type + '&pageIndex=' + pageIndex)
    }
  },

  Gold: {
    Info: () => {
      return api.get('/Gold')
    },

    Record: (pageIndex, type) => {
      pageIndex = pageIndex || 1
      type = type || 'Exchange'
      return api.get('/Gold/Record?type=' + type + '&pageIndex=' + pageIndex)
    }
  },

  Product: {
    Info: () => {
      return api.get('/IAP/Products')
    },

    Record: (pageIndex) => {
      pageIndex = pageIndex || 1
      return api.get('/IAP/OrderInfo/Records?pageIndex=' + pageIndex + '&pageSize=20')
    }
  },

  Exchange: {
    Items: () => {
      return api.get('/Exchange/Item')
    },

    Pay: (itemId, userinfo) => {
      return api.post('/Exchange/Item/' + itemId + '/Pay', qs.stringify(userinfo))
    }
  }
}



// WEBPACK FOOTER //
// ./src/api.js